export interface Testimonial {
  id: number;
  name: string;
  role: string;
  avatar: string;
  rating: number;
  comment: string;
}

export const testimonialsData: Testimonial[] = [
  {
    id: 1,
    name: 'Nguyễn Văn An',
    role: 'Chủ nhà hàng ABC',
    avatar:
      'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?q=80&w=1000&auto=format&fit=crop&ixlib=rb-4.0.3',
    rating: 5,
    comment:
      'Trứng gà của các bạn rất tươi ngon, chất lượng ổn định. Chúng tôi đã hợp tác được hơn 2 năm và rất hài lòng với dịch vụ. Giao hàng đúng hẹn, giá cả hợp lý.',
  },
  {
    id: 2,
    name: 'Trần Thị Bình',
    role: 'Bà nội trợ',
    avatar:
      'https://images.unsplash.com/photo-1494790108377-be9c29b29330?q=80&w=1000&auto=format&fit=crop&ixlib=rb-4.0.3',
    rating: 5,
    comment:
      'Tôi mua trứng gà ở đây thường xuyên cho gia đình. Trứng luôn tươi, lòng đỏ đậm đà, rất ngon. Đặc biệt là trứng gà ta, chất lượng tuyệt vời. Cảm ơn các bạn!',
  },
  {
    id: 3,
    name: 'Lê Minh Cường',
    role: 'Quản lý khách sạn XYZ',
    avatar:
      'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?q=80&w=1000&auto=format&fit=crop&ixlib=rb-4.0.3',
    rating: 5,
    comment:
      'Khách sạn chúng tôi sử dụng trứng gà số lượng lớn. Sản phẩm của các bạn đảm bảo chất lượng, giá cả cạnh tranh và dịch vụ giao hàng rất chuyên nghiệp. Khách hàng rất hài lòng.',
  },
  {
    id: 4,
    name: 'Phạm Thị Dung',
    role: 'Chủ cửa hàng tạp hóa',
    avatar:
      'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?q=80&w=1000&auto=format&fit=crop&ixlib=rb-4.0.3',
    rating: 5,
    comment:
      'Tôi bán trứng gà của các bạn tại cửa hàng. Khách hàng rất ưa chuộng vì trứng tươi ngon, giá cả hợp lý. Sản phẩm bán rất chạy, tôi sẽ tiếp tục hợp tác lâu dài.',
  },
  {
    id: 5,
    name: 'Hoàng Văn Em',
    role: 'Đầu bếp nhà hàng',
    avatar:
      'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?q=80&w=1000&auto=format&fit=crop&ixlib=rb-4.0.3',
    rating: 5,
    comment:
      'Là đầu bếp, tôi rất kỹ tính về nguyên liệu. Trứng gà của các bạn có chất lượng tốt, lòng đỏ đậm đà, phù hợp cho nhiều món ăn. Tôi rất tin tưởng và sẽ tiếp tục sử dụng.',
  },
  {
    id: 6,
    name: 'Võ Thị Phương',
    role: 'Người tiêu dùng',
    avatar:
      'https://images.unsplash.com/photo-1544005313-94ddf0286df2?q=80&w=1000&auto=format&fit=crop&ixlib=rb-4.0.3',
    rating: 5,
    comment:
      'Tôi đã thử nhiều nơi nhưng trứng gà ở đây là ngon nhất. Trứng tươi, vỏ sạch, lòng đỏ đẹp. Gia đình tôi rất thích, đặc biệt là các bé. Cảm ơn các bạn rất nhiều!',
  },
];

